module.exports = __webpack_public_path__ + "img/antes_despues_322.2eb840f2.png";